ActionList = require 'models/collections/action-list'
ActionListView = require 'views/action/action-list-view'
Auth = require 'db/auth'
MemberOnBoardView = require 'views/member-menu-profile/member-on-board-view'
Util = require 'lib/util'
View = require 'view'
getExperiment = require 'lib/experiments/simple-test'
template = require 'views/templates/invitee-orientation'
{ truncate } = require 'common/lib/util/text/truncate'
_ = require 'underscore'

ACTIONS_MAX_VISIBLE = 2
FACEPILE_MAX_VISIBLE = 3

module.exports = class InviteeOrientationView extends View
  className: 'invitee-orientation-wrapper'

  events:
    'click .js-close-orientation': 'onClose'

  initialize: ->
    @hasSetTracking = false

    # This view can only be rendered once. We only render after we have fetched
    # all the data we need from server, and after that every subsequent render
    # would show the exact same information -- it would be a no-op. The problem
    # with rerendering is that we don't want to run the animations more than
    # once, so we would need separate logic for rendering the first time vs.
    # subsequent times. That is too much complexity for a no-op, so instead we
    # only allow this view to render once.
    @hasRendered = false

    @actionListView = @collectionSubview ActionListView, new ActionList([], { @modelCache }),
      renderOpts:
        limit: ACTIONS_MAX_VISIBLE
        context: @model
        truncateComments: -> true
        extremeTruncation: true
        compact: true

    # Leave it ready for rendering.
    @actionListView.collection.reset(@renderableActions())

    # Sometimes this view loads before actions arrive, so listen for them and
    # re-render.
    @waitForId @model, =>
      @listenTo @modelCache, "add:Action:#{ @model.id } remove:Action:#{ @model.id } change:Action:#{ @model.id }", @frameDebounce =>
        if @actionListView.collection.length < ACTIONS_MAX_VISIBLE
          @actionListView.collection.reset(@renderableActions())
          @render()

  getInviteToken: ->
    Util.inviteTokenFor(@model.id)

  getMemberForAvatar: ->
    inviteToken = @getInviteToken()
    idInviter = inviteToken.split('-')[1]
    avatarMember = @modelCache.get('Member', idInviter)

    if !avatarMember?
      avatarMember = @model.adminList.models[0]

    avatarMember

  renderableMembers: ->
    renderableMembers = @model.orderedVisibleMembers().slice(0, FACEPILE_MAX_VISIBLE)

    if Auth.isLoggedIn()
      # The currently-logged-in member is always first, but they don't want to
      # be first, they want to see everyone else that's on the board - that's
      # the point of this project. Put them last.
      me = renderableMembers.shift()
      renderableMembers.push(me)

    renderableMembers

  renderableActions: ->
    @model.getActions()
      .filter((action) -> action.get('type') != 'addAttachmentToCard')
      .slice(0, ACTIONS_MAX_VISIBLE)

  shouldSeePopover: ->
    # you should see the popover if:
    # 1) you are in the experiment
    shouldSeePopover = getExperiment('boardInvitees').get('orient') &&
      # 2) you are logged in
      Auth.isLoggedIn() &&
      # 3) you haven't dismissed the popover before
      !Auth.me().isDismissed('invitee-orientation') &&
      # 4) you have an invite token for this board
      @getInviteToken()

    if !@hasSetTracking && shouldSeePopover
      getExperiment('boardInvitees').track()
    @hasSetTracking = true

    shouldSeePopover

  renderFacepile: ->
    subviews = for member in @renderableMembers()
      @subview MemberOnBoardView, member,
        board: @model
        notClickable: true
        small: true
        hideBadges: true

    @ensureSubviews(subviews.reverse(), @$('.js-invitee-orientation-facepile'))

  _getDataForMessage: ->
    allVisibleMembers = @model.orderedVisibleMembers()
    renderableMembers = @renderableMembers()

    visibleMembersCount: allVisibleMembers.length
    maxVisible: FACEPILE_MAX_VISIBLE
    firstMemberFullName: truncate(renderableMembers[0].get('fullName'), 30)
    boardName: @model.get('name')

  _getDataForAvatar: ->
    inviterAvatarHash: @getMemberForAvatar().get('avatarHash')
    inviterFullName: @getMemberForAvatar().get('fullName')
    inviterUsername: @getMemberForAvatar().get('username')
    inviterInitials: @getMemberForAvatar().get('initials')

  renderActivity: ->
    @actionListView.collection.reset(@renderableActions())
    @actionListView.setElement(@$('.invitee-orientation-activity-container')[0])
    @actionListView.render()

  render: ->
    if !@shouldSeePopover() || @hasRendered
      return @

    showActivity = getExperiment('boardInvitees').get('showActivity')
    if showActivity && @actionListView.collection.length == 0
      return @

    data = {}
    data = _.extend(data, @_getDataForAvatar())
    data = _.extend(data, @_getDataForMessage())

    @$el.html(template(data))
    @renderFacepile()

    $activityContainer = @$el.find('.invitee-orientation-activity-container')
    $messageContainer = @$el.find('.invitee-orientation-message-container')
    $avatarContainer = @$el.find('.invitee-orientation-avatar-container')

    if showActivity
      $activityContainer.addClass('arrow')
      @renderActivity()
      setTimeout (=>$activityContainer.addClass('active')), 1350
    else
      $activityContainer.hide()
      $messageContainer.addClass('arrow')

    setTimeout (=>$avatarContainer.addClass('active')), 1200
    setTimeout (=>$messageContainer.addClass('active')), 1350

    @hasRendered = true

    @

  onClose: ->
    Auth.me().dismiss('invitee-orientation')
    @remove()



// WEBPACK FOOTER //
// ./app/scripts/views/board/invitee-orientation-view.coffee